<script lang="ts">
  import { cn } from '../ui/utils';
  let { count, label, class: className = '', hidden = false, compact = false }: { count: number; label?: string; class?: string; hidden?: boolean; compact?: boolean } = $props();
</script>

<span class={cn('count-badge', count >= 100 && 'count-tag', compact && 'compact', className)} aria-label={label} aria-hidden={hidden || undefined} data-count-badge data-geometry={count < 100 ? 'circle' : undefined}>{count}</span>

<style>
  .count-badge { display: inline-grid; place-items: center; flex: none; width: 24px; height: 24px; padding: 0; border-radius: 50%; background: var(--warn); color: var(--on-warn); font-size: 12px; font-weight: 600; line-height: 1; font-variant-numeric: tabular-nums; white-space: nowrap; }
  .count-tag { width: auto; min-width: 28px; padding-inline: 5px; border-radius: 6px; }
  .compact { width: 16px; height: 16px; font-size: 10px; box-shadow: 0 0 0 2px var(--panel); }
  .compact.count-tag { width: auto; min-width: 20px; padding-inline: 3px; border-radius: 4px; }
</style>
